/** Lifecycle writes use captured command custody; display refresh is separate. */
import { useCallback } from 'react';
import { closeRun, commitRun, startRun, uncommitRun, unstartRun } from '@/api/runs';

const useRunCommitment = ({ commands, offline = false }) => {
  const execute = useCallback(async (runId, kind, send, message, options = {}) => {
    if (!runId || offline) return false;
    const result = await commands.execute({ kind, runId, source: 'cloud' }, {
      send: config => send(runId, config), message, ...options,
    });
    return result.accepted;
  }, [commands, offline]);

  const handleCommitRun = useCallback(runId => execute(runId, 'commit', commitRun,
    'Run committed - orders are now marked as taken', { orders: true }), [execute]);
  const handleUncommitRun = useCallback(runId => execute(runId, 'uncommit', uncommitRun,
    'Run uncommitted - orders are available again', { orders: true }), [execute]);
  const handleCloseRun = useCallback(runId => execute(runId, 'close', closeRun, 'Run closed'), [execute]);
  const handleStartRun = useCallback(runId => execute(runId, 'start', startRun, 'Run started',
    { refresh: 'detail' }), [execute]);
  const handleUnstartRun = useCallback(runId => execute(runId, 'unstart', unstartRun, 'Run unstarted',
    { refresh: 'detail' }), [execute]);

  return { handleCommitRun, handleUncommitRun, handleCloseRun, handleStartRun, handleUnstartRun };
};

export default useRunCommitment;
